// extracted by mini-css-extract-plugin
export var closeButton = "_22-3";
export var header = "_22-0";
export var link = "_22-1";
export var retryButton = "_22-2";